export default {
    'id': 'Id',
    'nombre': 'Nom',
    'telefono': 'Telèfon',
    'codigo': 'Codi',
    'email': 'Email',
    'activo': 'Actiu',
    'estado': 'Estat',
    'descripcion': 'Descripció',
    'usuario': 'Usuari',
    'clave': 'Clau',
    'all': 'Tots',
    'false': 'No',
    'true': 'Sí',
    'contact-form-send': "Formulari enviat amb èxit",
    'rows-per-page': 'Files por pàgina:',
    'rules': {
        'required': 'El camp és requerit',
        'email': 'El camp no cumpleix amb el format correcte'
    },
    'home': {
        'titulo': 'Benvingut',
        'parrafo': 'Ha instal·lat correctament la plantilla del ITI per agilitzar nous desenvolupaments de software amb tecnología .Net (Core) i VueJS. Abans de començar l\'invitem a consultar tota la informació posada a la seua disposició en les guies d\'inici.',
        'enlaces': 'Enllaços d\'interés',
        'front': 'Guia d\'inici Web',
        'back': 'Guia d\'inici Backend',
    },
    'menu': {
        'seguridad': 'Seguretat',
        'usuarios': 'Usuaris',
        'roles': 'Rols',
        'administracion': 'Administració',
        'tareas-programadas': 'Tasques Programades',
        'inicio-publica': 'Zona pública',
        'inicio-privada': 'Home',
        'insylay': 'Portal Insylay',
        'buscador-avanzado': 'Cercador avançat',
    },
    'menu-tooltip': {
        'areas-publicas': 'Temàtiques d\'interés general',
        'grupos-trabajo': 'Temàtica específica on col·laboren els experts sectorials i els col·laboradors',
        'areas-colaborativas': 'Projectes de col·laboració entre empreses'
    },
    'menuavatar': {
        'perfil': 'Perfil d\'usuari',
        'salir': 'Eixir',
        'salir-confirmacion': "Està segur d'eixir?"
    },
    'maestros': {
        'buscar': 'Buscar',
        'buscarPor': 'Cercar per',
        'descargar': 'Descarregar',
        'no-results': 'No hi ha resultats per a la recerca',
        'activo': 'Actiu',
        'admin': 'Admin',
        'editar': 'Editar',
        'eliminar': 'Eliminar',
        'mostrar': 'Mostrar',
        'pagina':'Pàgina',
        'filRow' : 'Notícies per pàgina',
        'explorar': 'Explorar',
    },
    'algoritmo': {
        'algoritmo': 'Algoritme',
        'algoritmos': 'Algoritmes',
        'codigo': 'Codi',
        'descripcion': 'Descripció',
        'imagen': 'Imatge docker',
        'estado': 'Estat',
        'registrado': 'Registrat',
        'punto-entrada': 'Punt entrada',
        'variables-entorno': 'Variables d\'entorn',
        'nombre-modulo': 'Nom del módul',
        'entrada': 'Entrada',
        'salida': 'Eixida',
        'slots': 'Container Slots',
        'categorias': 'Categories',
        'tipo-lanzamiento': 'Llançament',
        'nuevo-algoritmo': 'Nou algoritme',
        'registrar': 'Registrar',
        'desregistrar': 'Desregistrar',
        'activar': 'Activar',
        'desactivar': 'Desactivar'
    },
    'maestro-usuarios': {
        'usuario': 'Usuari',
        'email': 'Email',
        'id-externo': 'ID Extern',
        'razon-social': 'Raó social',
        'provincia': 'Província',
        'direccion': 'Direcció',
        'poblacion': 'Població',
        'codigo-postal': 'Codi postal',
        'pais': 'País',
        'cif': 'CIF',
        'clave': 'Clau',
        'repetir-clave': 'Repetir clau',
        'cambiar-clave': 'Canviar clau',
        'roles': 'Rols',
    },
    'maestro-roles': {
        'rol': 'Rol',
        'nombre': 'Nom',
    },
    'maestro-tareas': {
        'tareas-programadas': 'Tasques Programades',
        'tarea-programada': 'Tasca Programada',
        'timeout': 'Temps màxim (min)',
        'tipo-tarea': 'Tipus de tasca',
        'inicio-automatico': 'Inici automàtic',
        'cada': 'Cada',
        'minutos': 'minuts',
        'horas': 'hores',
        'cron': 'Periodicitat',
        'iniciar': 'Iniciar',
        'detener': 'Detenir',
        'en-ejecucion': 'En execució',
    },
    'maestro-configuracion': {
        'codigo-cnae': 'Codi cnae',
        'codigo-ler': 'Codi ler',
        'sector': 'Sector',
        'tipo-unidad': 'Tipus d\'unitat',
        'tipo-campo': 'Tipus de camp',
        'asociacion': "Asociació",
        'categoria': 'Categoria',
        'categoria-primer-nivel': 'Categoría primer nivell',
        'categoria-segundo-nivel': 'Categoría segon nivell',
        'categoria-tercer-nivel': 'Categoría tercer nivell',
        'categoria-cuarto-nivel': 'Categoría quart nivell',
        'primer-nivel': 'Primer nivell',
        'segundo-nivel': 'Segon nivell',
        'tercer-nivel': 'Tercer nivell',
        'cuarto-nivel': 'Quart nivell',
        'codigo': 'Codi',
        'descripcion': 'Descripció',
        'tipo': 'Tipus',
        'externalID': 'ID Extern'
    },
    'mensajes': {
        'save-ok': 'Canvis realitzats correctament',
        'ok': ' guardat correctament',
        'confirmar': 'Confirmació',
        'pregunta-borrar': '¿Està segur que vol eliminar "',
        'error-session': 'La sessió ha expirat',
        'error-categoria-padre-vacia': 'La categría pare no pot estar buida'
    },
    'header-footer': {
        'inicio': 'Inici',
        'proyecto': 'El projecte',
        'simbiosis': 'Simbiosi Industrial',
        'casos': "Casos d'èxit",
        'actualidad': 'Actualitat',
        'indicadores': 'Indicadors',
        'contacto': 'Contacte',
        'avisoLegal': 'Avís legal',
        'cookies': 'Política de cookies',
        'politicaPrivacidad': 'Política de privacitat',
        'private': 'Zona Privada',
        'observatorio': 'Observatori',
        'demostrador': 'Demostrador',
    },
    'inicio': {
        'calltoaction-placeholder-1': 'Oferta, demanda o ambdues',
        'calltoaction-placeholder-2': 'Descriu la teua oferta, demanda o ambdues',
        'sinergias': 'Buscar sinergies',
        'como-funciona': 'Com funciona?',
        'feature-1': 'Indiques els recursos que ofereixes',
        'feature-2': 'El sistema localitza sinergies',
        'feature-3': 'Contacta i arriba a acords',
        'empezar': 'Començar',
        'subscribe-text': 'Comença ja a oferir o demandar aqueixos recursos sense ús',
        'contacto': 'Contacte',
        'nombre': 'Nom complet',
        'email': 'Email',
        'asunto': 'Assumpte',
        'mensaje': 'El teu missatge',
        'enviar': 'Enviar',
        'seleccionar': 'Seleccionar',
    },
    'plantillas': {
        'plantilla': 'Plantilla',
        'plantillas': 'Plantilles',
        'listaPlantillas': 'Llista Plantilles',
        'nuevaPlantilla': 'Nova Plantilla',
        'id': 'Id',
        'title': 'Títol',
        'description': 'Descripció',
        'lerCodeCode': 'Ler Code',
        'sectorCode': 'Sector Code',
        'cnaeCodeCode': 'Cnae Code',
        'ler': 'LER',
        'sector': 'Sector',
        'cnae': 'CNAE',
        'category': 'Categoria',
        'level1': 'Nivell 1',
        'level2': 'Nivell 2',
        'level3': 'Nivell 3',
        'level4': 'Nivell 4',
        'campos': 'Camps',
        'nuevoCampo': 'Nou camp',
        'fieldCode': 'Identificador',
        'fieldLabel': 'Etiqueta',
        'fieldTypecode': 'Tipus',
        'fieldDescription': 'Descripció',
        'fieldType': 'Tipus de Camp',
        'unitType': 'Unitats',
        'defaultValue': 'Valor per defecte',
        'obligatory': 'Obligatori',
        'help': 'Ajuda',
        'validationRules': 'Regles de validació',
        'errorMessage': 'Missatge d\'error',
        'minimum': 'Mínim',
        'maximum': 'Màxim',
        'value': 'Valor',
        'listaValores': 'Llista de Valors',
        'editarListado': 'Per a editar el llistat faça clic',
        'version': 'Versió',
        'oferta': 'Oferta',
        'demanda': 'Demanda',
        'ofertaOdemanda': 'Oferta o Demanda',
        'lastModification': 'Última data de modificació',
        'tipo': 'Tipus',
        'rowsPage': 'Files per pàgina',
        'autor': 'Autor',
        'readOnly': 'Sols lectura',
        'tooltip-rules': "Expressió regular per a validar el contingut del camp introduït per l'usuari. Exemple: /^([0-9])*$/",
        'solo-activas': 'Només actives'

    },
    'versiones': {
        'descripcion': 'Descripció',
        'version': 'Versió',
        'activo': 'Actiu',
        'publicado': 'Publicat',
        'nuevaVersionCopia': 'Crear nova versió a partir d\'aquesta',
        'activar': 'Activar',
        'desactivar': 'Desctivar',
        'publicar': 'Publicar',
    },
    'mensajes-plantillas': {
        'save-ok': 'Canvis realitzats correctament',
        'ok': ' Guardat correctament',
        'confirmar': 'Confirmació',
        'incorrecto': 'Incorrecte',
        'pregunta-borrar-plantilla': '¿ Està segur que vol eliminar la plantilla ?',
        'pregunta-borrar-campo': '¿ Està segur que vol eliminar el camp ?',
        'pregunta-borrar-version': '¿ Està segur que vol eliminar la versió ?',
        'pregunta-salir': '¿ Està segur que desitja eixir ? Perdrà tots els canvis realitzats',
        'pregunta-guardar': '¿ Desitja guardar tots els canvis realitzats ?',
        'info-eliminar': 'S\'ha eliminat correctament',
        'info-crear': 'S\'ha creat correctament',
        'info-modificar': 'S\'ha modificat correctament',
        'info-error': 'S\'ha produït un error, torne a intentar-ho',
        'info-valida': 'Seleccione una opció vàlida',
        'info-sinCampos': 'Ha de crear un camp com a mínim',
        'faltan-campos': 'Falten camps per completar',
        'campos-sin-guardar': 'Segur que vol eixir ? L\'últim camp modificat no s\'ha guardat',
        'info-category': 'Selecciona una categoria',
        'info-error-oferta-demanda': 'S\'ha de seleccionar si la plantilla és d\'oferta, demanda o tots dos',
        'pregunta-activar-version': 'En activar una versió, es desactivaran les altres versions. Desitja continuar?',
        'pregunta-publicar-version': 'En publicar una versió, ja no es permet la seua edició o eliminació. Desitja continuar amb la publicació?',
    },
    'mensajes-algoritmos': {
        'info-error': 'S\'ha produït un error, torne a intentar-ho',
        'info-eliminar': 'S\'ha eliminat correctament',
        'pregunta-borrar-algoritmo': '¿ Està segur que vol eliminar el algoritme ?',
        'pregunta-guardar': '¿ Desitja guardar tots els canvis realitzats ?',
        'ok': ' Guardat correctament',
        'info-category': 'Selecciona una categoria',
        'pregunta-salir': '¿ Està segur que desitja eixir ? Perdrà tots els canvis realitzats',
    },
    'botones': {
        'guardar': 'Guardar',
        'cancelar': 'Cancel·lar',
        'editar': 'Editar',
        'editarPlantilla': 'Editar plantilla',
        'nuevoCampo': 'Nou Camp',
        'nuevaVersion': 'Nueva Versión',
        'subir': 'Pujar',
        'bajar': 'Baixar',
        'cerrar': 'Tancar',
        'volver': 'Tornar',
        'aqui': 'ací',
        'crear': 'Crear',
        'activate': 'Activar',
        'deactivate': 'Desactivar'
    },
    'vee-validate': {
        'required': 'Aquest camp no es pot deixar buit',
        'lerCode': 'El codi LER no és correcte',
        'sectorCode': 'El codi del Sector no és correcte',
        'cnaeCode': 'El codi CNAE no és correcte',
        'categoryCode': 'El codi de la Categoria no és correcte',
        'fieldTypeCode': 'El Tipus de Camp no és correcte',
        'unitTypeCode': 'El Tipus d\'Unitats no és correcte',
        'length': 'Este camp no pot ser major de ',
        'characters': ' caràcters',
        'valorMaximo': 'El valor màxim ha de ser major que el valor mínim'
    },
    'chat': {
        'ROOMS_EMPTY': 'No n\'hi ha chats',
        'ROOM_EMPTY': 'Cap chat seleccionat',
        'NEW_MESSAGES': 'Nou missatges',
        'MESSAGE_DELETED': 'Aquest missatge ha sigut eliminat',
        'MESSAGES_EMPTY': 'No n\'hi ha missatges',
        'CONVERSATION_STARTED': 'La conversació comença el :',
        'TYPE_MESSAGE': 'Escrigui el seu missatge',
        'SEARCH': 'Buscar',
        'IS_ONLINE': 'En llínea',
        'LAST_SEEN': 'Última conexió ',
        'IS_TYPING': 'está escriguint...',
        'nuevaSalaTitulo': 'Crear chat per nova àrea col·laborativa',
        'enviarMensajeBoton': 'Enviar'
    },
    'notificaciones': {
        'tabNotificaciones': 'Notificacions',
        'leido': 'Llegit',
        'leerSala': 'Marcar notificacions sala com llegides',
        'leerTodo': 'Marcar tot com llegit',
        'ver': 'Veure',
        'mensajeDe': 'Missatge de ',
        'sinergias': 'Notificació de sinergies',
        'chat': 'Nou missatge de chat',
        'sistema': 'Notificació de sistema',
        'default': 'Nova notificació',
        'documento': 'Nou arxiu',
        'evento': 'Nou event',
        'foro': 'Nou missatge de fòrum',
        'errorOrigen': 'Error obtenint origen missatge',
        'noHayNotificacion': 'No hi ha notificació carregada',
        'notificacionesNoLeidas': 'Notificacions no llegides',
        'notificacionesLeidas': 'Notificacions llegides',
        'enviarMensajeBoton': 'Enviar',
        'enviarMensajeTitulo': 'Enviar missatge'
    },
    'collaborative-area': {
        'myCollaborativeAreas': 'Les meues àrees col·laboratives',
        'collaborativeAreas': 'Àrees col·laboratives',
        'collaborativeArea': 'Àrea Col·laborativa',
        'publicArea': 'Àrees pùbliques',
        'workGroups': 'Grups de treball',
        'privateArea': 'Àrees privades',
        'info': 'Informació Àrea Col·laborativa',
        'nameArea': 'Nom Àrea',
        'numUsers': 'Nº usuaris',
        'numFiles': 'Nº documents',
        'file': 'Fitxer',
        'date': 'Data',
        'fileDate': 'Data fitxer',
        'messageDate': 'Data missatge',
        'lastMessage': 'Últim missatge xat',
        'message': 'Missatge',
        'replyDate': 'Data resposta',
        'lastPost': 'Últim foro amb resposta',
        'nextEvent': 'Pròxim esdeveniment',
        'name': 'Nom',
        'description': 'Descripció',
        'active': 'Activa',
        'type': 'Tipus',
        'nextEvents': 'Pròxims esdeveniments',
        'lastFiles': 'Últims documents',
        'lastMessages': 'Últims missatges',
        'users': 'Usuaris',
        'unnamedUser': 'Usuari sense nom',
        'noEvents': 'No hi ha esdeveniments per a mostrar',
        'noFiles': 'No hi ha arxius per a mostrar',
        'noMessages': 'No hi ha missatges per a mostrar',
        'noUsers': 'No hi ha usuaris per a mostrar',
        'access': 'Accedir',
        'newArea': 'Nova Àrea',
        'email': 'Email',
        'rol': 'Rol',
        'memberUsers': 'Usuaris membres',
        'newUser': 'Afegir nou usuari',
        'editRole': 'Editar rol',
        'pregunta-borrar-usuario-area': '¿ Està segur que vol eliminar l\'usuario de l\'àrea ?',
        'pregunta-abandonar-usuario-area': '¿ Està segur que desitja abandonar l\'àrea ?',
        'abandonedArea': 'Ha abandonat l\'àrea',
        'leaveArea': 'Abandonar àrea',
        'rowsPage': 'Files per pàgina',
        'activated': 'Àrea Activa',
        'disabled': 'Àrea Desactivada',
        'showActive': 'Mostrar Àrees Actives',
        'showInactive': 'Mostrar Àrees Desactivades',
    },
    'foro': {
        'forum-resume': 'Últimes interaccions del fòrum',
        'noForum-resum': 'No hi ha post ni respostes per a mostrar',
        'foro-date-creation': 'Data de creació:',
        'reply-placeholder': 'Responga ací',
        'replys': 'Respostes',
        'last-reply': 'Última resposta',
        'new-reply': 'Nova resposta en',
        'new-post': 'Nou post'
    },
    'roles-collaborative-area': {
        'OwnerCollaborativeArea': 'Propietari Àrea Col·laborativa',
        'CollaboratorCollaborativeArea': 'Col·laborador en Àrea Col·laborativa',
        'GuessCollaborativeArea': 'Invitat en Àrea Col·laborativa',
    },
    'types-collaborative-area': {
        'PublicArea': 'Àrea pública',
        'WorkGroups': 'Grup de treball',
        'PrivateArea': 'Àrea privada'
    },
    'offers-demands': {
        'myOffersDemands': 'Les meues ofertes i demandes',
        'matchingOfferDemand': 'Matching Oferta/Demanda',
        'code': 'Codi',
        'description': 'Descripció',
        'type': 'Tipus',
        'category1': 'Categoría 1',
        'category2': 'Categoría 2',
        'category3': 'Categoría 3',
        'category4': 'Categoría 4',
        'numMatching': 'Nº matching',
        'hasSynergies': 'Tiene Sinergias',
        'interested': 'M\'interessa',
        'oneInterested': 'L\'altre usuari ja ha indicat que esta interessat en el matching',
        'bothInterested': 'Ambdós parts estan interessades. Vols crear l\'àrea?',
        'createArea': 'Crear àrea col·laborativa',
        'accessArea': 'Accedix a l\'àrea col·laborativa',
        'result': 'Resultat',
        'label': 'Etiqueta',
        'information': 'Informació',
        'units': 'Unitats',
        'company': 'Empresa',
        'location': 'Ubicació',
        'offer': 'Oferta',
        'demand': 'Demanda',
        'postalCode': 'Codi postal',
        'photo': 'Foto',
        'name': 'Nom',
        'amount': 'Quantitat',
        'value': 'Valor',
    },
    'buscador-avanzado': {
        'buscador': 'Cercador avançat',
    },
    'account': {
        'cuenta': 'Compte',
        'nombre': 'Nom',
        'razon-social': 'Raó Social',
        'direccion': 'Direcció',
        'cnae': 'Codi CNAE',
        'asociacion': 'Asossiació',
        'usuario': 'Usuari',
        'email': 'Email',
        'postal': 'Codi Postal',
        'localidad': 'Localitat',
        'provincia': 'Província',
        'pais': 'País',
        'confirmar': 'Està segur que desitja guardar les noves dades?',
        'success': 'Dades guardades amb èxit',
        'error': "No s'han pogut guardar les dades",
    },
    'enum-plantillas': {
        'Numérico': 'Numèric',
        'Decimal': 'Decimal',
        'Fecha': 'Data',
        'Verdadero/Falso': 'Verdader/Fals',
        'Fichero': 'Fitxer',
        'Imagen': 'Imatge',
        'Listado': 'Llistat',
        'Rango': 'Rang',
        'Ler': 'Ler',
        'Cnae': 'Cnae',
        'Sector': 'Sector',
        'Texto': 'Text'
    },
    'enum-launch-type': {
        'Automatic': 'Automàtic',
        'Manual': 'Manual',
        'AutomaticAndManual': 'Automàtic i Manual'
    },
    'enum-user-role': {
        'Admin': 'Administrador',
        'EntityUser': 'Usuari Entitat',
        'ExpertUser': 'Usuari Expert'
    },
    'schedule': {
        'delete-confirm': 'Està segur que desitja esborrar aquest esdeveniment?',
        'delete': "No s'ha pogut esborrar l'esdeveniment",
        'upload': 'No se ha podido actualizar este eventos',
        'create': "No s'ha pogut crear l'esdeveniment",
        'show': "No s'han pogut carregar els esdeveniments",
    },
    'noticia': {
        'titular': 'Títol',
        'autor': 'Autor',
        'etiquetas': 'Etiquetes',
        'resumen': 'Resum',
        'mancheta': 'Mancheta',
        'categoria': 'Categoría',
        'instituto': 'Institut',
    }
};
